/**
 * ч.958: «Сховище» облікового запису — квота і зайнятість по організаціях.
 * Функціонал уже був на /profile (2026-08-31) — тут та сама сторінка як
 * розділ облікового запису (окремого пункту меню більше немає).
 */
import ProfilePage from '@/pages/ProfilePage';

export default function StorageSection() {
  return <ProfilePage />;
}
